export default "__VITE_ASSET__a2a86357__"